import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useCommon from "hooks/useCommon";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { getRoles } from "store/slice/rolesSlice";
import RolesTable from "./components/RolesTable";
import CreateRoleDialog from "./components/CreateRoleDialog";
import HotelSelector from "components/HotelSelector";
import { createRole } from "store/slice/rolesSlice";
import Snackbar from "components/Snackbar";
import VuiInput from "components/VuiInput";
import { clearCreateRoleState } from "store/slice/rolesSlice";

const Roles = () => {
  const { DISPATCH, NAVIFATE, STORE } = useCommon();
  const hotelId = STORE((state) => state.ui.hotelId);

  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    color: "success",
    title: "",
    content: "",
    icon: "check",
  });

  const showSnackbar = ({ color, title, content, icon = "check" }) => {
    setSnackbar({
      show: true,
      color,
      title,
      content,
      icon,
    });
  };

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, show: false }));

  const handleOpenCreateRole = () => {
    setOpen(true);
  };

  const handleCloseCreateRole = () => {
    setOpen(false);
    DISPATCH(clearCreateRoleState());
  };

  const handleCreateRole = async (payload) => {
    await DISPATCH(createRole(payload))
      .unwrap()
      .then((res) => {
        const success = res?.success;

        if (success) {
          DISPATCH(clearCreateRoleState());
          setSnackbar({
            ...snackbar,
            color: success ? "success" : "error",
            title: success ? "Role Created" : "Error",
            content: res?.message || "Client created successfully",
            icon: success ? "check" : "warning",
            show: true,
          });
          handleCloseCreateRole();
        }
      })
      .catch((err) => {
        // setSnackbar({
        //   ...snackbar,
        //   color: "error",
        //   title: "Error",
        //   content: err?.message || "Failed to create client",
        //   icon: "warning",
        //   show: true,
        // });
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox>
        <VuiBox py={1}>
          <VuiBox mb={3}>
            <Card>
              <VuiBox
                mb="22px"
                display="flex"
                flexWrap="wrap"
                gap={2}
                alignItems="center"
                justifyContent="space-between"
              >
                <VuiTypography
                  variant="lg"
                  sx={{
                    width: { xs: "100%", md: "auto" },
                    textAlign: { xs: "left", md: "left" },
                  }}
                >
                  User Roles
                </VuiTypography>

                {/* <VuiBox display="flex" alignItems="center" gap={2}> */}
                {/* <VuiBox>
                    <HotelSelector />
                  </VuiBox> */}

                <VuiBox
                  display="flex"
                  gap={2}
                  alignItems="center"
                  sx={{
                    // width: "100%",
                    // flexWrap: "nowrap",
                    // flexDirection: { xs: "column", sm: "row" },
                    flexDirection: "row",
                    width: { xs: "100%", md: "auto" },
                    justifyContent: { xs: "center", md: "flex-end" },
                  }}
                >
                  <VuiBox sx={{ width: { xs: "100%", sm: "220px" } }}>
                    <VuiInput
                      gradient
                      fullWidth
                      placeholder="Search roles..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </VuiBox>

                  <VuiButton
                    variant="contained"
                    color="primary"
                    onClick={handleOpenCreateRole}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      width: { sm: "50%", md: "auto" },
                    }}
                  >
                    <FaPlus size={"12px"} />
                    <VuiTypography
                      variant="text"
                      color="white"
                      sx={{ display: { xs: "none", sm: "block" }, lineHeight: 1 }}
                    >
                      Create Role
                    </VuiTypography>
                  </VuiButton>
                </VuiBox>
              </VuiBox>
              {/* </VuiBox> */}

              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                <RolesTable handleNotify={showSnackbar} search={search} />
              </VuiBox>
            </Card>
          </VuiBox>
        </VuiBox>
      </VuiBox>

      <Snackbar
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        open={snackbar.show}
        onClose={closeSnackbar}
        close={closeSnackbar}
      />

      <CreateRoleDialog
        open={open}
        onClose={handleCloseCreateRole}
        onSave={(payload) => handleCreateRole(payload)}
      />
    </DashboardLayout>
  );
};

export default Roles;
